<ng-container *ngIf="question">
  <ng-container *ngFor="let node of question.children; let i = index">
    <div class="mb-4" [ngClass]="root ? 'ml-1' : 'ml-5'"
      *ngIf="root || (question.answerText && (!node.toShowOnAnswer || (question.answerText === node.toShowOnAnswer)))">
      <label><span *ngIf="root"> <strong>{{i+1}}.</strong> </span><span class="ml-2">{{node.title}}</span></label>
      <span *ngIf="node.uiType == 'TOGGLE'" class="ml-3">
        <mat-button-toggle-group [(ngModel)]="node.answerText" (change)="updateChildNode(node)">
          <mat-button-toggle *ngIf="node.answerA !== null" [value]="node.answerA">{{node.answerA}}</mat-button-toggle>
          <mat-button-toggle *ngIf="node.answerB !== null" [value]="node.answerB">{{node.answerB}}</mat-button-toggle>
          <mat-button-toggle *ngIf="node.answerC !== null" [value]="node.answerC">{{node.answerC}}</mat-button-toggle>
          <mat-button-toggle *ngIf="node.answerD !== null" [value]="node.answerD">{{node.answerD}}</mat-button-toggle>
          <mat-button-toggle *ngIf="node.answerE !== null" [value]="node.answerE">{{node.answerE}}</mat-button-toggle>
          <mat-button-toggle *ngIf="node.answerF !== null" [value]="node.answerF">{{node.answerF}}</mat-button-toggle>
        </mat-button-toggle-group>
      </span>
      <span *ngIf="node.uiType == 'RADIO'" class="ml-3">
        <mat-radio-group [(ngModel)]="node.answerText" (change)="updateChildNode(node)">
          <mat-radio-button *ngIf="node.answerA !== null" [value]="node.answerA"> {{node.answerA}}</mat-radio-button>
          <mat-radio-button *ngIf="node.answerB !== null" [value]="node.answerB"> {{node.answerB}}</mat-radio-button>
          <mat-radio-button *ngIf="node.answerC !== null" [value]="node.answerC"> {{node.answerC}}</mat-radio-button>
          <mat-radio-button *ngIf="node.answerD !== null" [value]="node.answerD"> {{node.answerD}}</mat-radio-button>
          <mat-radio-button *ngIf="node.answerE !== null" [value]="node.answerE"> {{node.answerE}}</mat-radio-button>
          <mat-radio-button *ngIf="node.answerF !== null" [value]="node.answerF"> {{node.answerF}}</mat-radio-button>
        </mat-radio-group>
      </span>
      <span *ngIf="node.uiType == 'CHECK BOX'" class="ml-3">
        <mat-checkbox *ngIf="node.answerA !== null" [(ngModel)]="node.answerText"> {{node.answerA}}</mat-checkbox>
        <mat-checkbox *ngIf="node.answerB !== null" [(ngModel)]="node.answerText"> {{node.answerB}}</mat-checkbox>
        <mat-checkbox *ngIf="node.answerC !== null" [(ngModel)]="node.answerText"> {{node.answerC}}</mat-checkbox>
        <mat-checkbox *ngIf="node.answerD !== null" [(ngModel)]="node.answerText"> {{node.answerD}}</mat-checkbox>
        <mat-checkbox *ngIf="node.answerE !== null" [(ngModel)]="node.answerText"> {{node.answerE}}</mat-checkbox>
        <mat-checkbox *ngIf="node.answerF !== null" [(ngModel)]="node.answerText"> {{node.answerF}}</mat-checkbox>
      </span>
      <span *ngIf="node.uiType == 'TEXT'" class="ml-3">
        <input type="text" class="common-text-box" placeholder="Type ahead" [(ngModel)]="node.answerText">
      </span>
    </div>
    <div>
      <questionarieControl [question]="node"></questionarieControl>
    </div>
  </ng-container>
</ng-container>